import AuthActions from '@/store/actions/auth'
import UserActions from '@/store/actions/profile'
import AuthService from '@/services/AuthService'
import axios from 'axios'

const state = {
  token: localStorage.getItem('user-token') || '',
  status: '',
  hasLoadedOnce: false
};

const getters = {
  isAuthenticated: state => !!state.token,
  authStatus: state => state.status,
}

const actions = {
  [AuthActions.AUTH_REQUEST]: ({commit, dispatch}, user) => {
    return new Promise((resolve, reject) => {
      commit(AuthActions.AUTH_REQUEST)
      AuthService.getAuthToken(user.username, user.password)
      .then((resp) => {
        commit(AuthActions.AUTH_SUCCESS, resp)
        dispatch(UserActions.USER_PROFILE_REQUEST)
        resolve(resp)
      })
      .catch((err) => {
        commit(AuthActions.AUTH_ERROR, err)
        reject(err)
      })
    })
  },
  [AuthActions.AUTH_LOGOUT]: ({commit, dispatch}) => {
    return new Promise((resolve, reject) => {
      commit(AuthActions.AUTH_LOGOUT)
      localStorage.removeItem('user-token')
      resolve()
    })
  }
}

const mutations = {
  [AuthActions.AUTH_REQUEST]: (state) => {
    state.status = 'loading'
  },
  [AuthActions.AUTH_SUCCESS]: (state, resp) => {
    state.status = 'success'
    state.token = resp.access_token
    state.hasLoadedOnce = true
  },
  [AuthActions.AUTH_ERROR]: (state) => {
    state.status = 'error'
    state.hasLoadedOnce = true
  },
  [AuthActions.AUTH_LOGOUT]: (state) => {
    state.token = ''
  }
}

export default {
  state,
  getters,
  actions,
  mutations,
}
